const images = {
    rbfaFullLogoWithStripe: require('../assets/images/rbfa-full-logo-with-stripe.png'),
    rbfaColouredLogo: require('../assets/images/rbfa_coloured_logo.png'),
    blackRbfaFullLogoWithStripe: require('../assets/images/black-rbfa-full-logo-with-stripe.png'),
    whiteRbfaFullLogoWithStripe: require('../assets/images/white-rbfa-full-logo-with-stripe.png'),
};

export default images;
